var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStepperTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 20C16.0228 20 20.5 15.5228 20.5 10C20.5 4.47715 16.0228 0 10.5 0C4.97715 0 0.5 4.47715 0.5 10C0.5 15.5228 4.97715 20 10.5 20Z",
    fill: "#0ACD95"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9079_44959)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 10C2.5 11.0506 2.70693 12.0909 3.10896 13.0615C3.511 14.0321 4.10028 14.914 4.84315 15.6569C5.58601 16.3997 6.46793 16.989 7.43853 17.391C8.40914 17.7931 9.44943 18 10.5 18C11.5506 18 12.5909 17.7931 13.5615 17.391C14.5321 16.989 15.414 16.3997 16.1569 15.6569C16.8997 14.914 17.489 14.0321 17.891 13.0615C18.2931 12.0909 18.5 11.0506 18.5 10C18.5 8.94943 18.2931 7.90914 17.891 6.93853C17.489 5.96793 16.8997 5.08601 16.1569 4.34315C15.414 3.60028 14.5321 3.011 13.5615 2.60896C12.5909 2.20693 11.5506 2 10.5 2C9.44943 2 8.40914 2.20693 7.43853 2.60896C6.46793 3.011 5.58601 3.60028 4.84315 4.34315C4.10028 5.08601 3.511 5.96793 3.10896 6.93853C2.70693 7.90914 2.5 8.94943 2.5 10Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.83333 10L9.61111 11.7778L13.1667 8.22222",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.83333 10L9.61111 11.7778L13.1667 8.22222M2.5 10C2.5 11.0506 2.70693 12.0909 3.10896 13.0615C3.511 14.0321 4.10028 14.914 4.84315 15.6569C5.58601 16.3997 6.46793 16.989 7.43853 17.391C8.40914 17.7931 9.44943 18 10.5 18C11.5506 18 12.5909 17.7931 13.5615 17.391C14.5321 16.989 15.414 16.3997 16.1569 15.6569C16.8997 14.914 17.489 14.0321 17.891 13.0615C18.2931 12.0909 18.5 11.0506 18.5 10C18.5 8.94943 18.2931 7.90914 17.891 6.93853C17.489 5.96793 16.8997 5.08601 16.1569 4.34315C15.414 3.60028 14.5321 3.011 13.5615 2.60896C12.5909 2.20693 11.5506 2 10.5 2C9.44943 2 8.40914 2.20693 7.43853 2.60896C6.46793 3.011 5.58601 3.60028 4.84315 4.34315C4.10028 5.08601 3.511 5.96793 3.10896 6.93853C2.70693 7.90914 2.5 8.94943 2.5 10Z",
    stroke: "#0ACD95",
    strokeWidth: 1.84615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9079_44959"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(3 2.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepperTick);
export default __webpack_public_path__ + "static/media/stepperTick.79fbfbe75e5acc1a00d0270677ef20ef.svg";
export { ForwardRef as ReactComponent };